module.exports = __webpack_public_path__ + "img/vertical_4_6_8017.0ad2d7e4.png";